module.exports = __webpack_public_path__ + "media/dealer/warehouseAction-6f4bf161.jpg";